
import React, { useMemo, useState, useEffect, useRef } from "react";
import "./style/ProgressModal.css";
import { assets } from "../../../assets/assets";
import { BASE_URL_IMG } from "../../../api/apiConfig";

function ProgressModal({ isOpen, onClose, units = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);
  const images = useMemo(() => {
    return units.flatMap(
      (unit) =>
        unit.images?.map((img) => ({
          ...img,
          unitProgress: unit.progress,
          progressDeadline: unit.progress_deadline,
        })) || []
    );
  }, [units]);

  

  useEffect(() => {
    if (!carouselRef.current) return;

    const carouselEl = carouselRef.current;
    const onSlide = (e) => {
      setActiveIndex(e.to);
    };

    carouselEl.addEventListener("slid.bs.carousel", onSlide);

    return () => {
      carouselEl.removeEventListener("slid.bs.carousel", onSlide);
    };
  }, []);

  
  if (!isOpen) return null;

  return (
    <div className="progress-modal-overlay">
      <div className="modal-progress col-md-6" tabIndex="-1">
        <div className="modal-dialog-full col-12">
          <div className="modal-content col-12">
            <div className="modal-header">
              <p className="progress-header">Progress Details</p>
              <button type="button" className="btn-close-" onClick={onClose}>
                <img src={assets.close_circle} alt="Close Icon" />
              </button>
            </div>
          <div className="modal-body">
  {images.length === 0 ? (
    <p className="text-center text-white text-500 my-5">
      لا توجد صور لعرضها
    </p>
  ) : images.length === 1 ? (
    // حالة صورة واحدة فقط
    <div className="single-image-container">
      <img
        src={`${BASE_URL_IMG}/${images[0].image}`}
        className="d-block w-100"
        alt={images[0].comment || "progress image"}
      />
    </div>
  ) : (
    // حالة أكثر من صورة → carousel
    <div
      id="carouselExample"
      className="carousel slide"
      ref={carouselRef}
    >
      <div className="carousel-inner">
        {images.map((img, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <img
              src={`${BASE_URL_IMG}/${img.image}`}
              className="d-block w-100"
              alt={img.comment || "progress image"}
            />
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" />
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" />
      </button>
    </div>
  )}
</div>



            <div class="modal-footer justify-content-start">
              <div className="min-h-screen bg-gray-100 flex flex-col items-center m-0 mt-3">
                <div className="w-full max-w-md space-y-6">
                  {units.map((unit) => (
                    <div key={unit.id} className=" text-white">
                      {/* Progress bar */}
                      <div className="progress-precent flex items-center">
                        <p className="text-gray-500 text-sm m-0 text-start">
                          <span className="font-medium">Percent : </span>
                          {unit.progress}
                        </p>
                      </div>

                      {/* Extra info */}
                      <p className="text-gray-500 text-sm m-0 text-start">
                        <span className="font-medium">Image dates : </span>
                        {unit.progress_deadline}
                      </p>

                      <p className="text-gray-500 text-sm m-0 text-start">
                        <span className="font-medium">Comment : </span>
                        {images[activeIndex]?.comment}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgressModal;
